import React from 'react';

export const PreferencesSkeleton: React.FC = () => (
  <div className="container mx-auto px-3 sm:px-4 w-full min-h-[80vh] py-8">
    <div className="max-w-4xl mx-auto">
      <div className="h-10 w-3/4 bg-gray-200 rounded mb-8 animate-pulse" />
      <div className="card mb-8">
        <div className="h-6 w-2/3 bg-gray-200 rounded mb-6 animate-pulse" />
        <div className="space-y-4">
          <div className="h-12 bg-gray-100 rounded animate-pulse" />
          <div className="h-12 bg-gray-100 rounded animate-pulse" />
          <div className="h-12 bg-gray-100 rounded animate-pulse" />
          <div className="h-12 bg-gray-100 rounded animate-pulse" />
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-8">
        <div className="card h-40 animate-pulse" />
        <div className="card h-40 animate-pulse" />
      </div>
    </div>
  </div>
);

export const MealPlannerSkeleton: React.FC = () => (
  <div className="container mx-auto px-3 sm:px-4 w-full min-h-[80vh] py-8">
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-between mb-8">
        <div className="h-8 w-56 bg-gray-200 rounded animate-pulse" />
        <div className="h-10 w-48 bg-gray-100 rounded animate-pulse" />
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="card h-48 animate-pulse" />
        ))}
      </div>
    </div>
  </div>
);

export default { PreferencesSkeleton, MealPlannerSkeleton };
